import React, { useEffect, useState } from "react";
import { Row, Col, Modal, message, Radio, Button } from "antd";
import { stoageGetter } from "../../../helpers";

import Loader from "../../Loader/Loader";
import apiConfig from "../../../config/api.config";
import { Helmet } from "react-helmet";
import axiosRequest from "../../../axios-request/request.methods";
import { createRetryEnachPayload, createRetryOnlinePayload, createOnlineFlowConfig } from "./SubsequentPaymentUtility";

const { NODE_ENV } = apiConfig;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const TriggerSubsequentPayment = ({ isModalOpen, setIsModalOpen, proposalData, pageLoadAfterSubsequent }) => {
  const user = stoageGetter("user");
  const user_id = user?.id;
  const [loader, setLoader] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  useEffect(() => {
    populateDropdownValues();
  }, []);

  const getOnlineMandateFlag = async () => {
    const result = await axiosRequest.get(`user/getUser?userId=${user_id}`);
    const flag = result[0]?.channelCode?.onlineMandateFlag;
    return flag;
  };

  const populateDropdownValues = async () => {
    const flag = await getOnlineMandateFlag();
    setLoader(true);

    const endpoint = `user/getPaymentMaster?standingInstruction=false&proposalId=${proposalData?._id}&onlineMandateFlag=${flag}`;
    let result = await axiosRequest.get(endpoint);
    setLoader(false);
    console.log("payment DD result", result);
    if (result[0]) {
      const responseArray = result[0]?.subsequentPaymentMode;
      const filteredArray = responseArray.filter((item) => item.value !== "No selection");
      setPaymentModeOptions(filteredArray);
    }
  };

  const handleOkModal = () => {};

  const handleCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleSubsequentPayment = () => {
    if (selectedPaymentMode === "enach") {
      handleTriggerEnach(selectedPaymentMode);
    } else if (selectedPaymentMode === "upi" || selectedPaymentMode === "ccdc") {
      handleTriggerOtherMethod(selectedPaymentMode);
    } else {
      message.error("Please select a subsequent payment mode");
    }
  };

  const handleTriggerEnach = async (method) => {
    setLoader(true);
    const EnachPayload = await createRetryEnachPayload(proposalData, method);

    await axiosRequest
      .post(`user/enach_retry`, EnachPayload)
      .then((res) => {
        console.log("trigger enach result", res);

        if (res) {
          setIsModalOpen(false);
          pageLoadAfterSubsequent();
        } else {
          setLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleTriggerOtherMethod = async (method) => {
    setLoader(true);
    const OnlinePayload = await createRetryOnlinePayload(method, proposalData);
    const endpoint = "user/create_order?retry=true";

    console.log("online payload", OnlinePayload);

    try {
      let result = await axiosRequest.post(endpoint, OnlinePayload);
      setLoader(false);
      if (result?.errCode !== 256) {
        const flow_config = createOnlineFlowConfig(result, method);

        var config = {
          flowConfig: flow_config,
          flowType: "payments",
        };

        await window.loadBillDeskSdk(config);
      } else {
        setLoader(false);
      }
    } catch (err) {
      console.log("Error in create_order", err);
    }
  };

  return (
    <>
      <Modal title="Trigger Subsequent Payment" visible={isModalOpen} onOk={handleOkModal} onCancel={handleCancelModal} closable footer={null}>
        <Loader formloader={loader} />
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            Kindly select a Subsequent Payment Mode to proceed with for this policy : <strong>{proposalData?.policyId}</strong>
          </Col>
        </Row>
        <br />
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Radio.Group onChange={(e) => setSelectedPaymentMode(e.target.value)} value={selectedPaymentMode} defaultValue={selectedPaymentMode} style={{ display: "flex", flexDirection: "column" }}>
              {paymentModeOptions.map((mode) => (
                <Radio key={mode.value} value={mode.value}>
                  {mode.label}
                </Radio>
              ))}
            </Radio.Group>
          </Col>
        </Row>
        <br />
        <Row gutter={16} justify="end">
          <Button
            type="primary"
            style={{
              color: "#004FB6",
              backgroundColor: "#FFD900",
            }}
            onClick={handleSubsequentPayment}
          >
            Proceed
          </Button>
        </Row>
      </Modal>

      {NODE_ENV === "production" ? (
        <Helmet>
          <script type="module" src="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"></script>
          <script nomodule="" src="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk.js"></script>
          <link target="_blank" href="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css" rel="stylesheet" />
        </Helmet>
      ) : (
        <Helmet>
          <script type="module" src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"></script>
          <script nomodule="" src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js"></script>
          <link target="_blank" href="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css" rel="stylesheet" />
        </Helmet>
      )}
    </>
  );
};

export default TriggerSubsequentPayment;
